import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({ standalone: false,
  selector: 'mx-table-search',
  templateUrl: './mx.table-search.component.html',
  styleUrls: ['./mx.table-search.component.scss'],
})
export class MxTableSearchComponent extends MxBaseComponent {
  @Input() searchValue: string;
  @Input() visible: boolean = true;
  @Output() searchValueChange: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() onModelChange: EventEmitter<any> = new EventEmitter<any>();
}
